import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { 
    FaWifi, 
    FaTv, 
    FaShower, 
    FaCoffee, 
    FaBroom, 
    FaSnowflake,
    FaBath,
    FaBed,
    FaUsers,
    FaRulerCombined,
    FaCheck,
    FaChevronLeft,
    FaTimes
} from 'react-icons/fa';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/RoomDetails.css';

// Import local images
import homeHero from '../assets/images/home.jpg'; // This will be the hero image for ALL rooms
import roomsImg from '../assets/images/rooms.jpg'; // Use rooms.jpg instead of batlokoa.jpg
import baphuthi from '../assets/images/baphuthi.jpg';
import baphuthii from '../assets/images/baphuthii.jpg';
import bap from '../assets/images/bap.jpg';
import baphuthimakhoakhoa from '../assets/images/baphuthimakhoakhoa.jpg';
import makhoa from '../assets/images/makhoa.jpg';
import makhoakhoa from '../assets/images/makhoakhoa.jpg';
import makhoablack from '../assets/images/makhoablack.jpg';
import blackdoor from '../assets/images/blackdoor.jpg';
import blackshower from '../assets/images/blackshower.jpg';
import makholokoebed from '../assets/images/makholokoebed.jpg';
import makholo from '../assets/images/makholo.jpg';
import makholokoetv from '../assets/images/makholokoetv.jpg';
import basiatv from '../assets/images/basiatv.jpg';
import bathtub from '../assets/images/bathtub.jpg';
import basia from '../assets/images/basia.jpg';
import bedside from '../assets/images/bedside.jpg';
import roomview from '../assets/images/roomview.jpg';
import tv from '../assets/images/tv.jpg';

const RoomDetails = () => {
    const { id } = useParams();
    const [selectedImage, setSelectedImage] = useState(null);
    
    // Function to check if current date is in August
    const isAugust = () => {
        const now = new Date();
        const month = now.getMonth();
        return month === 7;
    };

    // Function to get the promotion price based on date
    const getDisplayPrice = (originalPrice) => {
        if (isAugust()) {
            return "M800";
        }
        return originalPrice;
    };
    
    // All 8 rooms data with more gallery images - UPDATED NAMES
    const rooms = [
        {
            id: 1,
            name: "Baphuthi",
            shortDescription: "Bold, open, and contemporary.",
            fullDescription: "Experience the bold and contemporary design of Baphuthi. This room features a stunning transparent shower, modern furnishings, and a comfortable double bed. Perfect for travelers who appreciate open, airy spaces with a touch of modern luxury. The room is designed to create a sense of freedom and transparency, reflecting the modern Basotho spirit.",
            price: "M900",
            gallery: [baphuthimakhoakhoa, baphuthi, makhoakhoa, baphuthii, bap, makhoa],
            amenities: [
                { icon: FaWifi, label: "Free WiFi" },
                { icon: FaTv, label: "Flat-screen TV" },
                { icon: FaShower, label: "Transparent Shower" },
                { icon: FaCoffee, label: "Tea/Coffee" },
                { icon: FaBroom, label: "Daily Housekeeping" },
                { icon: FaSnowflake, label: "Mini Fridge" }
            ],
            feature: "Transparent Shower",
            bedType: "Double Bed",
            guests: "2 Adults",
            size: "25 m²"
        },
        {
            id: 2,
            name: "Bakubung",
            shortDescription: "Minimalist and airy.",
            fullDescription: "Bakubung offers a minimalist and airy atmosphere. The transparent shower adds a modern touch while keeping the space open and bright. Designed for guests who appreciate clean lines, simplicity, and a clutter-free environment. Perfect for those seeking a peaceful and uncomplicated stay.",
            price: "M900",
            gallery: [makholokoebed, makholo, makhoa, makholokoetv, baphuthi, makhoakhoa],
            amenities: [
                { icon: FaWifi, label: "Free WiFi" },
                { icon: FaTv, label: "Flat-screen TV" },
                { icon: FaShower, label: "Transparent Shower" },
                { icon: FaCoffee, label: "Tea/Coffee" },
                { icon: FaBroom, label: "Daily Housekeeping" },
                { icon: FaSnowflake, label: "Mini Fridge" }
            ],
            feature: "Transparent Shower",
            bedType: "Double Bed",
            guests: "2 Adults",
            size: "25 m²"
        },
        {
            id: 3,
            name: "Batsoeneng",
            shortDescription: "Sleek, industrial-chic.",
            fullDescription: "Batsoeneng embodies sleek industrial-chic design. The black shower door creates a bold statement while maintaining a sophisticated edge. Perfect for modern travelers who appreciate contemporary style, exposed elements, and a design-forward aesthetic that doesn't compromise on comfort.",
            price: "M1,000",
            gallery: [blackdoor, baphuthimakhoakhoa, makhoablack, makhoakhoa, blackshower, baphuthii],
            amenities: [
                { icon: FaWifi, label: "Free WiFi" },
                { icon: FaTv, label: "Flat-screen TV" },
                { icon: FaShower, label: "Black Shower Door" },
                { icon: FaCoffee, label: "Tea/Coffee" },
                { icon: FaBroom, label: "Daily Housekeeping" },
                { icon: FaSnowflake, label: "Mini Fridge" }
            ],
            feature: "Black Shower Door",
            bedType: "Double Bed",
            guests: "2 Adults",
            size: "25 m²"
        },
        {
            id: 4,
            name: "Basia",
            shortDescription: "Focus on relaxation and luxury.",
            fullDescription: "Basia is all about relaxation and luxury. Unwind in the private bathtub after a long day. This room is designed for guests seeking a tranquil escape with premium comfort and elegant finishes. Soft lighting, plush textures, and a calming color palette create the perfect retreat.",
            price: "M950",
            gallery: [baphuthimakhoakhoa, basia, basiatv, bathtub, makhoakhoa, makhoa],
            amenities: [
                { icon: FaWifi, label: "Free WiFi" },
                { icon: FaTv, label: "Flat-screen TV" },
                { icon: FaBath, label: "Private Bathtub" },
                { icon: FaCoffee, label: "Tea/Coffee" },
                { icon: FaBroom, label: "Daily Housekeeping" },
                { icon: FaSnowflake, label: "Mini Fridge" }
            ],
            feature: "Private Bathtub",
            bedType: "Double Bed",
            guests: "2 Adults",
            size: "30 m²"
        },
        {
            id: 5,
            name: "Batloung",
            shortDescription: "Classic elegance.",
            fullDescription: "Batloung combines classic elegance with modern comfort. The private bathtub adds a touch of luxury, while the timeless design creates a warm and inviting atmosphere for a memorable stay. Traditional elements blend seamlessly with contemporary amenities for a truly refined experience.",
            price: "M950",
            gallery: [baphuthimakhoakhoa, basia, basiatv, bathtub, makhoakhoa, makhoa],
            amenities: [
                { icon: FaWifi, label: "Free WiFi" },
                { icon: FaTv, label: "Flat-screen TV" },
                { icon: FaBath, label: "Private Bathtub" },
                { icon: FaCoffee, label: "Tea/Coffee" },
                { icon: FaBroom, label: "Daily Housekeeping" },
                { icon: FaSnowflake, label: "Mini Fridge" }
            ],
            feature: "Private Bathtub",
            bedType: "Double Bed",
            guests: "2 Adults",
            size: "30 m²"
        },
        {
            id: 6,
            name: "Bafokeng",
            shortDescription: "Sophisticated and grounded.",
            fullDescription: "Bafokeng offers sophisticated design that feels grounded and welcoming. The black shower door adds a modern accent, while the overall ambiance remains calm and refined for a peaceful stay. Earthy tones and quality materials create a space that feels both luxurious and approachable.",
            price: "M1,000",
            gallery: [makholokoebed, baphuthimakhoakhoa, makhoakhoa, blackshower, makhoa, tv],
            amenities: [
                { icon: FaWifi, label: "Free WiFi" },
                { icon: FaTv, label: "Flat-screen TV" },
                { icon: FaShower, label: "Black Shower Door" },
                { icon: FaCoffee, label: "Tea/Coffee" },
                { icon: FaBroom, label: "Daily Housekeeping" },
                { icon: FaSnowflake, label: "Mini Fridge" }
            ],
            feature: "Black Shower Door",
            bedType: "Double Bed",
            guests: "2 Adults",
            size: "25 m²"
        },
        {
            id: 7,
            name: "Bataung",
            shortDescription: "Strong, modern accents.",
            fullDescription: "Bataung features strong modern accents that make a statement. The black shower door complements the contemporary design, perfect for guests who appreciate bold aesthetics and modern luxury. This room is for those who want their space to reflect confidence and style.",
            price: "M1,000",
            gallery: [makholokoebed, roomview, makhoakhoa, blackshower, tv, baphuthii],
            amenities: [
                { icon: FaWifi, label: "Free WiFi" },
                { icon: FaTv, label: "Flat-screen TV" },
                { icon: FaShower, label: "Black Shower Door" },
                { icon: FaCoffee, label: "Tea/Coffee" },
                { icon: FaBroom, label: "Daily Housekeeping" },
                { icon: FaSnowflake, label: "Mini Fridge" }
            ],
            feature: "Black Shower Door",
            bedType: "Double Bed",
            guests: "2 Adults",
            size: "25 m²"
        },
        {
            id: 8,
            name: "Bakoena",
            shortDescription: "Regal and polished.",
            fullDescription: "Bakoena delivers a regal and polished experience. Every detail is crafted for excellence, from the black shower door to the premium finishes throughout the room. The epitome of luxury for discerning guests who expect nothing but the best. Perfect for special occasions or when you simply want to treat yourself.",
            price: "M1,000",
            gallery: [makholokoebed, bedside, makhoakhoa, blackshower, basiatv, baphuthii],
            amenities: [
                { icon: FaWifi, label: "Free WiFi" },
                { icon: FaTv, label: "Flat-screen TV" },
                { icon: FaShower, label: "Black Shower Door" },
                { icon: FaCoffee, label: "Tea/Coffee" },
                { icon: FaBroom, label: "Daily Housekeeping" },
                { icon: FaSnowflake, label: "Mini Fridge" }
            ],
            feature: "Black Shower Door",
            bedType: "Double Bed",
            guests: "2 Adults",
            size: "25 m²"
        }
    ];

    const room = rooms.find(r => r.id === parseInt(id));

    const openLightbox = (img) => {
        setSelectedImage(img);
    };

    const closeLightbox = () => {
        setSelectedImage(null);
    };

    if (!room) {
        return (
            <div>
                <Header />
                <div className="not-found">
                    <h1>Room Not Found</h1>
                    <p>Sorry, the room you're looking for doesn't exist.</p>
                    <Link to="/rooms" className="btn btn-primary">Back to Rooms</Link>
                </div>
                <Footer />
            </div>
        );
    }

    // Split gallery into rows of 3
    const splitIntoRows = (images, itemsPerRow = 3) => {
        const rows = [];
        for (let i = 0; i < images.length; i += itemsPerRow) {
            rows.push(images.slice(i, i + itemsPerRow));
        }
        return rows;
    };

    const galleryRows = splitIntoRows(room.gallery, 3);

    return (
        <div className="room-details-page">
            <Header />
            
            {/* Hero Section - Uses home.jpg for ALL rooms */}
            <section className="room-hero">
                <div className="room-hero-image-wrapper">
                    <img 
                        src={homeHero} 
                        alt={room.name} 
                        className="room-hero-img"
                    />
                    <div className="hero-content-overlay">
                        <h1>{room.name}</h1>
                        <p>{room.shortDescription}</p>
                        {isAugust() && (
                            <div className="hero-promotion-badge">August Special: M800/night</div>
                        )}
                    </div>
                </div>
            </section>

            {/* Room Details Content */}
            <section className="room-details-content">
                <div className="container">
                    <div className="details-grid">
                        {/* Left Column - Room Info */}
                        <div className="details-info">
                            <h2>{room.name}</h2>
                            <div className="room-price-large">
                                {getDisplayPrice(room.price)}
                                <span> / night</span>
                                {isAugust() && room.price !== "M800" && (
                                    <span className="original-price-large"> {room.price}</span>
                                )}
                            </div>
                            <div className="room-feature-badge-large">{room.feature}</div>
                            
                            <p className="room-full-description">{room.fullDescription}</p>
                            
                            {/* Room Specs */}
                            <div className="room-specs">
                                <div className="spec-item">
                                    <span className="spec-icon"><FaBed /></span>
                                    <div>
                                        <strong>Bed Type</strong>
                                        <p>{room.bedType}</p>
                                    </div>
                                </div>
                                <div className="spec-item">
                                    <span className="spec-icon"><FaUsers /></span>
                                    <div>
                                        <strong>Occupancy</strong>
                                        <p>{room.guests}</p>
                                    </div>
                                </div>
                                <div className="spec-item">
                                    <span className="spec-icon"><FaRulerCombined /></span>
                                    <div>
                                        <strong>Room Size</strong>
                                        <p>{room.size}</p>
                                    </div>
                                </div>
                            </div>
                            
                            {/* Amenities Full List */}
                            <div className="amenities-full">
                                <h3>Room Amenities</h3>
                                <div className="amenities-grid">
                                    {room.amenities.map((amenity, index) => {
                                        const IconComponent = amenity.icon;
                                        return (
                                            <div key={index} className="amenity-full-item">
                                                <span className="amenity-check"><FaCheck /></span>
                                                <IconComponent className="amenity-icon" />
                                                {amenity.label}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                        
                        {/* Right Column - Booking Card */}
                        <div className="booking-card">
                            <div className="booking-card-inner">
                                <h3>Book This Room</h3>
                                <div className="booking-price">
                                    <span className="price">{getDisplayPrice(room.price)}</span>
                                    <span className="per-night">per night</span>
                                </div>
                                
                                <div className="booking-features">
                                    <div className="booking-feature">
                                        <span><FaCheck /></span> 50% deposit secures your booking
                                    </div>
                                    <div className="booking-feature">
                                        <span><FaCheck /></span> Balance due on arrival
                                    </div>
                                    <div className="booking-feature">
                                        <span><FaCheck /></span> Free cancellation up to 14 days before arrival
                                    </div>
                                    <div className="booking-feature">
                                        <span><FaCheck /></span> Deposit non-refundable for cancellations
                                    </div>
                                    <div className="booking-feature">
                                        <span><FaCheck /></span> Secure online booking
                                    </div>
                                </div>
                                
                                <Link to={`/bookings/${room.id}`} className="btn btn-primary btn-block">Book Now</Link>
                                <p className="booking-note">Contact us for special rates or group bookings</p>
                            </div>
                        </div>
                    </div>
                    
                    {/* Gallery Section - Images in rows of 3 */}
                    <div className="room-gallery">
                        <h3>Photo Gallery</h3>
                        <div className="gallery-container">
                            {galleryRows.map((row, rowIndex) => (
                                <div key={rowIndex} className="gallery-row">
                                    {row.map((img, imgIndex) => (
                                        <div 
                                            key={imgIndex} 
                                            className="gallery-item"
                                            onClick={() => openLightbox(img)}
                                        >
                                            <img 
                                                src={img} 
                                                alt={`${room.name} view ${rowIndex * 3 + imgIndex + 1}`}
                                                className="gallery-img"
                                                loading="lazy"
                                            />
                                        </div>
                                    ))}
                                    {/* Add empty placeholders if row has less than 3 items */}
                                    {row.length < 3 && [...Array(3 - row.length)].map((_, i) => (
                                        <div key={`empty-${i}`} className="gallery-item gallery-placeholder"></div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* Lightbox Modal - Shows full image when clicked */}
            {selectedImage && (
                <div className="lightbox" onClick={closeLightbox}>
                    <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                        <img src={selectedImage} alt="Full size view" />
                        <button className="lightbox-close" onClick={closeLightbox}>
                            <FaTimes />
                        </button>
                    </div>
                </div>
            )}

            {/* Back to Rooms Button */}
            <section className="back-link">
                <div className="container">
                    <Link to="/rooms" className="btn btn-outline-dark">
                        <FaChevronLeft /> Back to All Rooms
                    </Link>
                </div>
            </section>

            {/* Similar Rooms CTA */}
            <section className="similar-rooms">
                <div className="container">
                    <h3>Explore Other Rooms</h3>
                    <p>Discover our other uniquely designed rooms</p>
                    <Link to="/rooms" className="btn btn-primary">View All Rooms</Link>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default RoomDetails;